import { render, staticRenderFns } from "./TodaysDateButtonComponent.vue?vue&type=template&id=da2fb1ba&"
import script from "./TodaysDateButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./TodaysDateButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da2fb1ba')) {
      api.createRecord('da2fb1ba', component.options)
    } else {
      api.reload('da2fb1ba', component.options)
    }
    module.hot.accept("./TodaysDateButtonComponent.vue?vue&type=template&id=da2fb1ba&", function () {
      api.rerender('da2fb1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/TodaysDateButtonComponent.vue"
export default component.exports